import { Component, Prop } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { FORM_CONSTANTS } from "@/shared/constants/FormConstants";
import { AVAILABILITY_CONSTANTS } from "../../constants/AvailabilityConstants";

Vue.use(Vuetify);
@Component({
  name: "OptionsModal"
})
export default class OptionsModal extends Vue {
  @Prop() private optionsModal!: boolean;
  @Prop() private optionsModalText!: string;
  @Prop() private optionsModalTitle!: string;
  @Prop() private optionList?: [{ name: ""; value: "" }];

  optionSelected = 0;

  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  cardClass = STYLE_CLASSES.CARD;

  selectOptionList = [{ name: "", value: "" }];
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;

  async mounted() {
    this.optionSelected = 0;
    if (this.optionList) {
      this.selectOptionList = this.optionList;
    } else {
      this.selectOptionList = AVAILABILITY_CONSTANTS.OPTION_MODAL.OPTION_LIST;
    }
  }

  accept() {
    const option = this.selectOptionList[this.optionSelected].value;
    this.$emit("optionsModalAccept", option);
  }

  cancel() {
    this.$emit("optionsModalCancel");
  }
}
